/*
  LIOR - the help center ("שאלות נפוצות") in the style of iOS 27
  (assets/lior-ios-help.css; the page body is output inside .lpg.lpg--help).

  The page body brings its own accordion script (one answer open at a time,
  aria-expanded and a "+" / "—" on each question). That script keeps doing
  the work; this file dresses the page and follows it:
    - the body's <h1> is empty, so the page title of the theme's header
      (.lpg-head) is moved into the body's header, under its eyebrow
    - the contact capsules get glyphs where their emoji were (the emoji stay
      in the page, hidden from view and from screen readers)
    - each question becomes a Settings row: a tile by topic, the topic as the
      title and the question under it, and the "+" drawn as a chevron
    - the answers open and close on a spring, following aria-expanded as the
      page's script sets it; if that script is missing, this one toggles the
      same way
    - the quick-help card becomes a contact card, the tip a note
    - from 6 questions on, an iOS search bar filters them
  No word or link is changed, removed or reordered.
*/
(function () {
  'use strict';

  if (window.__liorIosHelp) return;
  window.__liorIosHelp = true;

  var D = document;
  var W = window;
  var SEARCH_MIN = 6;

  /* Glyphs on the 24-point grid of the iOS menu, round caps and joins */
  var G = {
    truck: '<path d="M3.5 7h10v8.5h-10z"/><path d="M13.5 10h3.6l3.4 3.4v2.1h-7"/><circle cx="7.3" cy="17" r="1.6"/><circle cx="16.8" cy="17" r="1.6"/>',
    exchange: '<path d="M4.6 11.2a7.4 7.4 0 0 1 13-4.6"/><path d="M17.9 3.5v3.4h-3.4"/><path d="M19.4 12.8a7.4 7.4 0 0 1-13 4.6"/><path d="M6.1 20.5v-3.4h3.4"/>',
    returns: '<path d="M9 7.5 5.5 11 9 14.5"/><path d="M5.5 11h9a4 4 0 0 1 0 8H12"/>',
    xmark: '<circle cx="12" cy="12" r="8.6"/><path d="m9.3 9.3 5.4 5.4M14.7 9.3l-5.4 5.4"/>',
    alert: '<path d="M10.3 4.7 3.3 17.1a2 2 0 0 0 1.7 3h14a2 2 0 0 0 1.7-3L13.7 4.7a2 2 0 0 0-3.4 0z"/><path d="M12 9.6v4.2"/><path class="lhc-dot" d="M12 16.8h.01"/>',
    seal: '<path d="M12 3.4 14.1 5l2.6-.2.8 2.5 2.2 1.5-.9 2.4.9 2.4-2.2 1.5-.8 2.5-2.6-.2L12 20.6 9.9 19l-2.6.2-.8-2.5-2.2-1.5.9-2.4-.9-2.4 2.2-1.5.8-2.5 2.6.2z"/><path d="m9.2 12.2 2 2 3.8-4.1"/>',
    card: '<rect x="3" y="5.6" width="18" height="12.8" rx="2.4"/><path d="M3 9.8h18M6.6 14.6h3.8"/>',
    ruler: '<path d="M4.3 15.4 15.4 4.3a1.4 1.4 0 0 1 2 0l2.3 2.3a1.4 1.4 0 0 1 0 2L8.6 19.7a1.4 1.4 0 0 1-2 0l-2.3-2.3a1.4 1.4 0 0 1 0-2z"/><path d="m7.4 12.3 1.6 1.6M9.9 9.8l1.1 1.1M12.4 7.3l1.6 1.6"/>',
    sparkle: '<path d="M11 3.5l1.7 4.8 4.8 1.7-4.8 1.7L11 16.5l-1.7-4.8L4.5 10l4.8-1.7z"/><path d="M17.5 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/>',
    chat: '<path d="M4.5 6.5A2.5 2.5 0 0 1 7 4h10a2.5 2.5 0 0 1 2.5 2.5v7A2.5 2.5 0 0 1 17 16h-6.2l-4.3 3.6V16H7a2.5 2.5 0 0 1-2.5-2.5z"/>',
    question: '<circle cx="12" cy="12" r="8.6"/><path d="M9.6 9.6a2.4 2.4 0 1 1 3.4 2.2c-.6.3-1 .8-1 1.5v.5"/><path class="lhc-dot" d="M12 16.8h.01"/>',
    clock: '<circle cx="12" cy="12" r="8.6"/><path d="M12 7.4V12l3.1 2"/>',
    phone: '<path d="M7.4 3.8h2.2l1.3 4-1.8 1.3a10.6 10.6 0 0 0 5.8 5.8l1.3-1.8 4 1.3v2.2a2 2 0 0 1-2.1 2A15.6 15.6 0 0 1 5.4 5.9a2 2 0 0 1 2-2.1z"/>',
    mail: '<rect x="3.2" y="5.4" width="17.6" height="13.2" rx="2.6"/><path d="m4.2 7.4 7.8 5.8 7.8-5.8"/>',
    bulb: '<path d="M9.3 17.6h5.4M10.2 20.6h3.6"/><path d="M12 3.4a6 6 0 0 0-3.5 10.9c.5.4.8.9.8 1.5v1.8h5.4v-1.8c0-.6.3-1.1.8-1.5A6 6 0 0 0 12 3.4z"/>',
    search: '<circle cx="10.6" cy="10.6" r="6.4"/><path d="m15.4 15.4 4.6 4.6"/>',
    clear: '<circle class="lhc-fill" cx="12" cy="12" r="9.6"/><path class="lhc-on" d="m9.3 9.3 5.4 5.4M14.7 9.3l-5.4 5.4"/>',
    wa: '<path class="lhc-fill" fill-rule="evenodd" d="M12 2.6a9.4 9.4 0 0 0-8.1 14.2L2.6 21.4l4.7-1.2A9.4 9.4 0 1 0 12 2.6zm5.4 13.2c-.2.6-1.3 1.2-1.8 1.3-.5 0-.9.2-3.1-.6-2.6-1-4.3-3.7-4.4-3.9-.1-.2-1-1.4-1-2.7s.7-1.9.9-2.2c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.3 0 .5l-.4.6-.4.4c-.1.1-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.1 1 2.1 1.3 2.4 1.4.3.2.5.1.6-.1l.9-1.1c.2-.3.4-.2.7-.1l1.8.9c.3.1.5.2.5.3.1.2.1.7-.1 1.3z"/>'
  };

  function ic(name, cls) {
    return '<svg class="lhc-ic' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">' + (G[name] || G.question) + '</svg>';
  }
  function tile(name, colour) {
    return '<span class="lhc-tile" data-lhc-c="' + colour + '" aria-hidden="true">' + ic(name) + '</span>';
  }

  /* What a question is about, from its topic first, then its words
     (first match wins; colour follows meaning across the site) */
  var TOPICS = [
    [/משלוח|אספק|shipping|delivery/i, 'truck', 'green'],
    [/החלפ|exchange/i, 'exchange', 'purple'],
    [/החזר|refund|return/i, 'returns', 'blue'],
    [/ביטול|לבטל|cancel/i, 'xmark', 'red'],
    [/פגם|פגום|תקלה|defect|damage/i, 'alert', 'red'],
    [/איכות|quality/i, 'seal', 'orange'],
    [/מעקב|שליח|מתי|tracking|courier/i, 'clock', 'orange'],
    [/תשלום|אשראי|payment/i, 'card', 'indigo'],
    [/מידה|מידות|size/i, 'ruler', 'teal'],
    [/טיפול|ניקוי|care/i, 'sparkle', 'mint'],
    [/וואטסאפ|קשר|שירות|whatsapp|contact/i, 'chat', 'green']
  ];
  function topicOf(s) {
    for (var i = 0; i < TOPICS.length; i++) if (TOPICS[i][0].test(s)) return TOPICS[i];
    return null;
  }

  /* "Topic – question" */
  var SEP = /\s+[–—-]\s+/;

  /* An emoji at the start of a link: a pictograph with its variation
     selector, skin tone or joined parts (no \p{} support: emoji stay) */
  var EMOJI = null;
  try {
    EMOJI = new RegExp('^(\\s*)(\\p{Extended_Pictographic}(?:\\p{Variation_Selector}|\\p{Emoji_Modifier}|\\p{Join_Control}\\p{Extended_Pictographic})*)', 'u');
  } catch (e) {
    EMOJI = null;
  }

  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function reduced() { return !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function wrapNode(node, cls, tag) {
    var s = D.createElement(tag || 'span');
    s.className = cls;
    node.parentNode.insertBefore(s, node);
    s.appendChild(node);
    return s;
  }

  /* ------------------------------------------------------------------------
     The header: the page title under the eyebrow; glyphs on the capsules
     ------------------------------------------------------------------------ */
  function dressHead(root) {
    var hero = root.querySelector('.faqLx-hero');
    var h1 = hero && hero.querySelector('.faqLx-title');
    if (!h1 || clean(h1.textContent)) return;
    h1.classList.add('lhc-void');
    var lpg = root.closest('.lpg');
    var head = null;
    if (lpg) {
      for (var n = lpg.firstElementChild; n; n = n.nextElementSibling) {
        if (n.classList.contains('lpg-head')) { head = n; break; }
      }
    }
    var title = head && head.querySelector('.lpg-title');
    if (!title || !clean(title.textContent)) return;
    h1.parentNode.insertBefore(title, h1);
    head.classList.add('lhc-merged');
  }

  function dressPill(a) {
    if (a.classList.contains('lhc-cap')) return;
    var href = a.getAttribute('href') || '';
    var kind = /wa\.me|whatsapp/i.test(href) ? 'wa' : /^tel:/i.test(href) ? 'phone' : /^mailto:/i.test(href) ? 'mail' : '';
    if (!kind) return;
    var t = null;
    for (var n = a.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && clean(n.nodeValue)) { t = n; break; }
      if (n.nodeType === 1) break;
    }
    if (!t) return;
    var lead = null;
    var m = EMOJI && EMOJI.exec(t.nodeValue);
    if (m && m[2]) {
      var emo = t.splitText(m[1].length);
      t = emo.splitText(m[2].length);
      lead = wrapNode(emo, 'lhc-emo');
      lead.setAttribute('aria-hidden', 'true');
    }
    var words = wrapNode(t, 'lhc-cap-t');
    (lead || words).insertAdjacentHTML('beforebegin', ic(kind));
    a.setAttribute('data-lhc-k', kind);
    a.classList.add('lhc-cap');
  }

  /* ------------------------------------------------------------------------
     The questions: Settings rows, opened on a spring
     ------------------------------------------------------------------------ */
  function dressQuestion(q, n) {
    var a = q.nextElementSibling;
    if (!a || !a.classList.contains('faqLx-a')) a = null;

    /* button and answer stay next to each other (the page's script opens
       btn.nextElementSibling), inside one row of the group */
    var item = D.createElement('div');
    item.className = 'lhc-item';
    q.parentNode.insertBefore(item, q);
    /* everything from the question to its answer, spaces included, so the
       page's text runs exactly as before */
    var end = (a || q).nextSibling;
    for (var node = q, next; node && node !== end; node = next) {
      next = node.nextSibling;
      item.appendChild(node);
    }

    var plus = q.querySelector('.faqLx-plus');
    if (plus) plus.setAttribute('aria-hidden', 'true');

    /* the words of the question: everything but the "+" */
    var parts = Array.prototype.filter.call(q.childNodes, function (c) {
      return c !== plus && !(c.nodeType === 3 && !clean(c.nodeValue)) && c.nodeType !== 8;
    });
    var topicText = '';
    var qt = null;
    if (parts.length) {
      qt = D.createElement('span');
      qt.className = 'lhc-qt';
      q.insertBefore(qt, parts[0]);
      var tn = parts.length === 1 && parts[0].nodeType === 3 ? parts[0] : null;
      var m = tn && SEP.exec(tn.nodeValue);
      var before = m ? clean(tn.nodeValue.slice(0, m.index)) : '';
      var after = m ? clean(tn.nodeValue.slice(m.index + m[0].length)) : '';
      if (m && before && after && before.length <= 28) {
        var sep = tn.splitText(m.index);
        var ask = sep.splitText(m[0].length);
        qt.appendChild(wrapNode(tn, 'lhc-topic'));
        qt.appendChild(wrapNode(sep, 'lhc-sep'));
        qt.appendChild(wrapNode(ask, 'lhc-ask'));
        topicText = before;
      } else {
        var t = D.createElement('span');
        t.className = 'lhc-topic';
        qt.appendChild(t);
        parts.forEach(function (p) { t.appendChild(p); });
      }
    }
    var full = clean((qt || q).textContent);
    var hit = topicOf(topicText) || topicOf(full) || [null, 'question', 'gray'];
    item.setAttribute('data-lhc-c', hit[2]);
    q.insertAdjacentHTML('afterbegin', tile(hit[1], hit[2]));

    var inner = null;
    if (a) {
      inner = D.createElement('div');
      inner.className = 'lhc-a-in';
      while (a.firstChild) inner.appendChild(a.firstChild);
      a.appendChild(inner);
      if (!q.id) q.id = 'lhc-q-' + n;
      if (!a.id) a.id = 'lhc-a-' + n;
      q.setAttribute('aria-controls', a.id);
    }

    return {
      item: item,
      q: q,
      a: a,
      inner: inner,
      open: false,
      hay: norm(full + ' ' + (a ? a.textContent : ''))
    };
  }

  var EASE_FALLBACK = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var ease = EASE_FALLBACK;

  /* One running animation per element, kept until the next one replaces it
     (cancelling also lifts a finished animation's fill) */
  function play(el, frames, opts, done) {
    var anim = null;
    var o = { duration: opts.duration, delay: opts.delay || 0, easing: opts.easing || ease, fill: opts.fill || 'none' };
    try {
      anim = el.animate(frames, o);
    } catch (e) {
      try {
        o.easing = EASE_FALLBACK;
        anim = el.animate(frames, o);
      } catch (e2) {
        anim = null;
      }
    }
    el.__lhcAnim = anim;
    if (!anim) { if (done) done(null); return null; }
    if (done) anim.onfinish = function () { done(anim); };
    return anim;
  }
  function stop(el) {
    if (el && el.__lhcAnim) {
      el.__lhcAnim.onfinish = null;
      el.__lhcAnim.cancel();
      el.__lhcAnim = null;
    }
  }

  /* Open or close one answer on the spring, from wherever it is now
     (a second tap mid-way turns it around without a jump) */
  function setOpen(it, open, instant) {
    it.open = open;
    var a = it.a;
    var inner = it.inner;
    if (!a) return;
    var shown = a.classList.contains('lhc-open');
    var from = shown ? a.getBoundingClientRect().height : 0;
    var alpha = shown && inner ? parseFloat(W.getComputedStyle(inner).opacity) : 0;
    if (isNaN(alpha)) alpha = 1;
    stop(a);
    stop(inner);
    var still = instant || reduced();

    if (open) {
      a.classList.add('lhc-open');
      if (still) return;
      var to = a.getBoundingClientRect().height;
      if (Math.abs(to - from) < 1) return;
      play(a, [{ height: from + 'px' }, { height: to + 'px' }], { duration: 560 });
      if (inner) play(inner, [{ opacity: alpha, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }], { duration: 460, delay: shown ? 0 : 40, fill: 'backwards' });
      return;
    }

    if (!shown) return;
    if (still || from < 1) { a.classList.remove('lhc-open'); return; }
    if (inner) play(inner, [{ opacity: alpha }, { opacity: 0 }], { duration: 200, easing: 'ease-out', fill: 'forwards' });
    play(a, [{ height: from + 'px' }, { height: '0px' }], { duration: 440, fill: 'forwards' }, function () {
      if (it.open) return;
      a.classList.remove('lhc-open');
      stop(a);
      stop(inner);
    });
  }

  /* ------------------------------------------------------------------------
     The search bar (6 questions or more)
     ------------------------------------------------------------------------ */
  function norm(s) {
    return clean(String(s || '').toLowerCase().replace(/[׳״'"`.,:;!?()–—־-]/g, ' '));
  }

  function buildSearch(root, acc, items) {
    var grid = root.querySelector('.faqLx-grid');
    if (!grid || root.querySelector('.lhc-search')) return;
    var box = D.createElement('div');
    box.className = 'lhc-search';
    box.setAttribute('role', 'search');
    box.setAttribute('data-lhc-ui', '');
    box.innerHTML =
      '<label class="lhc-search__field">' + ic('search') +
      '<input class="lhc-search__input" type="search" placeholder="חיפוש בשאלות" aria-label="חיפוש בשאלות" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="search"></label>' +
      '<button class="lhc-search__clear" type="button" aria-label="ניקוי החיפוש" hidden>' + ic('clear') + '</button>';
    grid.parentNode.insertBefore(box, grid);

    var empty = D.createElement('p');
    empty.className = 'lhc-empty';
    empty.setAttribute('data-lhc-ui', '');
    empty.setAttribute('role', 'status');
    empty.hidden = true;
    empty.textContent = 'לא נמצאו שאלות';
    acc.insertAdjacentElement('afterend', empty);

    var input = box.querySelector('input');
    var clear = box.querySelector('button');

    function filter() {
      var words = norm(input.value).split(' ').filter(Boolean);
      var shown = 0;
      items.forEach(function (it) {
        var ok = words.every(function (w) { return it.hay.indexOf(w) !== -1; });
        it.item.hidden = !ok;
        if (ok) shown++;
      });
      acc.classList.toggle('lhc-none', !shown);
      empty.hidden = shown > 0;
      clear.hidden = !input.value;
    }

    input.addEventListener('input', filter);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) {
        input.value = '';
        filter();
      }
    });
    clear.addEventListener('click', function () {
      input.value = '';
      filter();
      input.focus();
    });
  }

  /* ------------------------------------------------------------------------
     Quick help: the contact card and the tip
     ------------------------------------------------------------------------ */
  function dressSide(root) {
    qa(root, '.faqLx-side > .faqLx-mini').forEach(function (m) {
      if (m.classList.contains('lhc-contact') || m.classList.contains('lhc-tip')) return;
      var link = m.querySelector('a[href]');
      if (link) {
        var wa = /wa\.me|whatsapp/i.test(link.getAttribute('href') || '');
        m.classList.add('lhc-contact');
        m.insertAdjacentHTML('afterbegin', tile(wa ? 'wa' : 'chat', 'green'));
        if (link.classList.contains('faqLx-cta') && !link.querySelector('.lhc-ic')) link.insertAdjacentHTML('afterbegin', ic(wa ? 'wa' : 'chat'));
        var note = m.querySelector('.faqLx-note');
        if (note && !note.querySelector('.lhc-ic') && /שעות|\d{1,2}:\d{2}/.test(note.textContent)) note.insertAdjacentHTML('afterbegin', ic('clock'));
      } else {
        m.classList.add('lhc-tip');
        m.insertAdjacentHTML('afterbegin', ic('bulb'));
      }
    });
  }

  /* ------------------------------------------------------------------------
     Dress the page
     ------------------------------------------------------------------------ */
  function dress(root) {
    var lpg = root.closest('.lpg--help') || root;
    var spring = W.getComputedStyle(lpg).getPropertyValue('--lhc-spring').trim();
    if (spring) ease = spring;

    dressHead(root);
    qa(root, '.faqLx-actions a.faqLx-pill').forEach(dressPill);
    dressSide(root);

    var acc = root.querySelector('.faqLx-acc');
    var items = acc ? qa(acc, '.faqLx-q').map(dressQuestion) : [];

    if (!acc || !items.length) {
      root.setAttribute('data-lhc', '');
      return;
    }

    /* follow the page's own script: whatever sets aria-expanded, the answer
       springs open or closed to match (its inline max-height is let go) */
    function sync(instant) {
      items.forEach(function (it) {
        if (it.a && it.a.style.maxHeight) it.a.style.removeProperty('max-height');
        var want = it.q.getAttribute('aria-expanded') === 'true';
        if (want !== it.open) setOpen(it, want, instant);
      });
    }

    if ('MutationObserver' in W) {
      var mo = new MutationObserver(function () { sync(false); });
      items.forEach(function (it) { mo.observe(it.q, { attributes: true, attributeFilter: ['aria-expanded'] }); });
    }

    /* if the page's script did not answer a click, toggle the same way it
       would: one answer open at a time, "+" closed and "—" open */
    function rowOf(e) {
      var q = e.target && e.target.closest ? e.target.closest('.faqLx-q') : null;
      return q && acc.contains(q) ? q : null;
    }
    acc.addEventListener('click', function (e) {
      var q = rowOf(e);
      if (q) q.__lhcWas = q.getAttribute('aria-expanded');
    }, true);
    acc.addEventListener('click', function (e) {
      var q = rowOf(e);
      if (!q) return;
      var was = q.__lhcWas;
      q.__lhcWas = null;
      if (was == null || q.getAttribute('aria-expanded') !== was) return;
      items.forEach(function (it) {
        it.q.setAttribute('aria-expanded', 'false');
        var p = it.q.querySelector('.faqLx-plus');
        if (p) p.textContent = '+';
      });
      if (was !== 'true') {
        q.setAttribute('aria-expanded', 'true');
        var p = q.querySelector('.faqLx-plus');
        if (p) p.textContent = '—';
      }
      if (!('MutationObserver' in W)) sync(false);
    });

    /* lets :active show on iOS Safari */
    root.addEventListener('touchstart', function () {}, { passive: true });

    /* from here the answers are this file's to show (until now the page's
       own max-height accordion was in charge) */
    root.setAttribute('data-lhc', '');
    sync(true);

    if (items.length >= SEARCH_MIN) {
      try {
        buildSearch(root, acc, items);
      } catch (err) {
        if (W.console && console.warn) console.warn('[lior-ios-help]', err);
      }
    }
  }

  function boot() {
    var root = D.querySelector('.lpg--help .faqLx');
    if (!root || root.hasAttribute('data-lhc')) return;
    try {
      dress(root);
    } catch (err) {
      /* the page and its own accordion stay as they are */
      if (W.console && console.warn) console.warn('[lior-ios-help]', err);
    }
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
